import React from "react";
import { FieldRendererProps } from "../types";
import { InputColor } from "../../input-color";

export const ColorFieldRenderer: React.FC<FieldRendererProps> = ({
  campo, modo, getFieldValue, handleInputChange,
}) => (
  <InputColor
    campo={campo}
    modo={modo}
    getFieldValue={getFieldValue}
    handleInputChange={handleInputChange}
    apenasLeitura={campo.apenasLeitura || false}
  />
);
